import { AirServerError } from '@airreading/common';
import { isAxiosError, type AxiosError } from 'axios';
import { useEffect } from 'react';

import { useToast } from '@/components/ui/hooks/use-toast';

export function axiosErrorFrom(error: unknown): AxiosError | undefined {
  if (isAxiosError(error)) {
    return error;
  }
  return undefined;
}

export function airServerErrorOf(error: AxiosError): AirServerError | undefined {
  const data = error?.response?.data;
  if (data instanceof AirServerError) {
    // An `AirServerError` object retrieved from Axios is a plain object. By
    // calling this static constructor, we ensure that we get an instantiated
    // object so that instance methods work correctly.
    return AirServerError.from(data);
  }
  return undefined;
}

export function airServerErrorFrom(error: unknown): AirServerError | undefined {
  const e = axiosErrorFrom(error);
  return e ? airServerErrorOf(e) : undefined;
}

export function useErrorToast(error: Error | null, fallbackMessage: string): void {
  const { toast } = useToast();

  useEffect(() => {
    if (error) {
      toast({
        variant: 'destructive',
        description: airServerErrorFrom(error)?.userFacingMessage ?? fallbackMessage,
      });
    }
  }, [error, toast, fallbackMessage]);
}
